import { TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Text, VSpacing } from '@hh.ru/magritte-ui';

import { NotificationKind } from 'src/components/Notifications/types';

export const FILTER_MORE_THAN_ONE_YEAR = 'FILTER_MORE_THAN_ONE_YEAR';

const TrlKeys = {
    header: 'statportal.notification.filterMoreThanOneYear.header',
    message: 'statportal.notification.filterMoreThanOneYear',
};

const FilterMoreThanOneYear: TranslatedComponent = ({ trls }) => (
    <Text style="contrast">
        <p>{trls[TrlKeys.header]}</p>
        <VSpacing default={6} />
        <p>{trls[TrlKeys.message]}</p>
    </Text>
);

export default {
    Element: translation(FilterMoreThanOneYear),
    kind: NotificationKind.Error,
    autoClose: true,
};
